import { render, staticRenderFns } from "./setInfo.vue?vue&type=template&id=07439504&scoped=true&"
import script from "./setInfo.vue?vue&type=script&lang=js&"
export * from "./setInfo.vue?vue&type=script&lang=js&"
import style0 from "./setInfo.vue?vue&type=style&index=0&id=07439504&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07439504",
  null
  
)

export default component.exports